<template>
  <div class="app-container">
    <!-- 面包屑 -->
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }" replace>
          <el-icon name="arrow-left" /> 返回</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>

    <div class="main">
      <section>
        <div class="title">公司介绍</div>
        <div>
          <p>
          北京数音未来科技有限公司<br/>
          ——用科技重塑创作，让内容触手可及<br/>
        </p>
        </div>
        <br/>
        <div>
          <p>
          北京数音未来科技有限公司坐落于北京市朝阳区万恒时代中心B座10层1010，是一家以前沿科技驱动的数字内容创新企业。旗下平台“PlayList”不仅是正版音乐素材的引领者，更是国内首家全面整合AIGC技术的内容创作平台，致力于通过“AI+内容”的深度融合，赋能每一位创作者。<br/>
        </p>
        </div>
        <br/>
        <p>
          平台核心优势：
          <br/>
        </p>
        <br/>
        <p>
          · 内容生态全覆盖：PlayList提供一站式数字素材库，涵盖音乐、音效、图片、视频四大类别，满足全场景创作需求，助力内容制作高效、专业、多元。<br/>
          · AIGC技术引领行业：国内率先引入AI音乐、AI视频、AI图片、AI语音生成技术，实现智能创作、风格定制、实时生成，大幅降低创意门槛，让科技真正赋能内容创新。<br/>
          · 订阅制普惠模式：坚持高性价比的会员订阅服务，用户可通过灵活方案无限畅享全站AIGC内容与正版素材库，让优质创作资源人人可及。<br/>
          · 正版授权与智能体验：与全球顶尖版权方合作，保障内容合规安全；智能推荐与AI辅助工具深度融合，实现“所想即所得”的创作流程。<br/>
        </p>
        <br/>
        <p>
我们正在推动的变革：<br/><br/>
从“使用素材”到“创造素材”，PlayList以AIGC技术重新定义内容生产。无论是AI生成背景音乐、智能剪辑视频片段，还是一键生成营销海报与配音，我们让每一个创意想法都能快速落地，助力个人、企业、机构在数字内容时代保持竞争力。
<br/><br/>

使命与愿景：
<br/><br/>
数音未来坚信，技术不应是高墙，而应是桥梁。我们致力于构建一个人人可创作、处处有灵感的智能内容生态，成为中国AIGC内容平台的开拓者与守护者。<br/>
<br/>
---
<br/><br/>
✨ PlayList 平台亮点<br/>
✅ 全素材覆盖：音乐、音效、图片、视频，一站集成<br/>
✅ AIGC原创力：AI音乐/视频/图片/语音，智能生成，自定义风格<br/>
✅ 订阅制轻享：高性价比会员，无限下载，商用无忧<br/>
✅ 正版保障：全球合作版权，合规授权，创作更安心<br/>
<br/>
🚀 立即体验智能创作新时代
<br/><br/>
地址：北京市朝阳区万恒时代中心B座10层1010<br/>
官网：PlayList · AI驱动的一站式内容创作平台
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style lang="scss" scoped>
.app-container {
  width: 1320px;
  margin: 0 auto;
  padding-top: 70px;
  min-height: calc(100vh - 268px);
  padding-bottom: 80px;
  .breadcrumb {
    width: 1200px;
    padding: 40px 0;
    ::v-deep {
      .el-breadcrumb__inner {
        @include font-bold($size: 20px, $color: rgba(51, 51, 51, 0.6));
        line-height: 28px;
        cursor: pointer;
      }
      .el-breadcrumb__separator {
        @include font-bold(
          $size: 18px,
          $color: rgba(51, 51, 51, 0.6),
          $weight: bold
        );
      }
    }
  }
  .main {
    min-height: 420px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(33, 48, 83, 0.07);
    border-radius: 12px;
    padding: 38px 50px;
    section {
      font-size: 18px;
      font-weight: 400;
      color: rgba(51, 51, 51, 0.8);
      line-height: 28px;
      .title {
        font-size: 20px;
        font-weight: 600;
        color: #333333;
        line-height: 28px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
